import React, {useEffect, useState} from 'react';
import {Alert, Button, Flex, Select} from "antd";
import {BiReset} from "react-icons/bi";
import {Accordion} from '../../../../components';
import {useViewerStore} from "../../../../store/store";
import {useCalculationStates} from '../../../../hooks/calculationStateHook';
import {ACCESS_MULTIPLIERS, FACE_IDEAL_API, MODULE_GRAPH, SHADE_CALCULATIONS} from '../../../../services/siteCalculationState';
import ToggleLossesConfirm from "../../../../components/Layout-Components/Editor-Layout/Losses-Toggle/ToggleLossesConfirm";
import {Info} from "@phosphor-icons/react";
import LossesInfoDetail from "../../../../components/Layout-Components/Editor-Layout/Losses-Toggle/LossesInfoDetail";
import { VendorKey } from '../../../../Constants';
import { RoofMesh } from '../../../../@types/types';

interface RoofWiseShadePoint {
  roofName: string;
  roofId: string;
  shadePoints: ShadePointInfo[];
}

interface ShadePointInfo {
  shadePointName: number;
  ptHashValue: number;
}

const ShadePointProperties: React.FC = () => {
    const [selectedDropdownVendor, setSelectedDropdownVendor] = useState<VendorKey>("oneDRAW");
    const [showToggleConfirm, setShowToggleConfirm] = useState(false);
    const {sceneViewer, selectedLossesVendor} = useViewerStore(), {roofMeshArr} = sceneViewer;
    const {needsUpdate} = useCalculationStates([ACCESS_MULTIPLIERS, FACE_IDEAL_API, SHADE_CALCULATIONS, MODULE_GRAPH]);

    const [roofWiseShadePoints, setRoofWiseShadePoints] = useState<RoofWiseShadePoint[]>([]);
    const [selectedShade, setSelectedShade] = useState<string>();
    const [isLoading, setIsLoading] = useState<boolean>();

    const vendorOptions = [
        {label: "oneDRAW", value: 'oneDRAW'},
        {label: "GoodLeap", value: 'GoodLeap'},
        {label: "GoodLeap Analysis Case 2", value: 'GoodLeapAnalysisCase2'},
        {label: "GoodLeap Analysis Case 3", value: 'GoodLeapAnalysisCase3'},
    ];

    const handleVendorChange = (value: VendorKey) => {
        setSelectedDropdownVendor(value);
        setShowToggleConfirm(true);
    };

    const revertToOriginaloneDRAWLoss = () => {
        handleVendorChange("oneDRAW");
    };

    const onClickRow = (e: React.MouseEvent<HTMLTableRowElement>) => {
        const id = (e.target as HTMLElement).id;
        setSelectedShade(id);
        // resetSelected();
        const [roofFaceId, ptIdx] = id.split('-');
        if (roofFaceId) sceneViewer.selectShadePoint(roofFaceId, ptIdx);
    }

    useEffect(() => {
        roofMeshArr.forEach((roof: RoofMesh) => {
            const roofChildren = roof.children
            roofChildren.forEach((child: any) => {
                if (child.name === 'shadePoint') {
                    child.visible = true
                }
            })
        });
        // sceneViewer.setEPCStatus(); // To set shade point colors
        // sceneViewer.setVisibleGroup("pathway", false);

        return () => {
            // resetSelected();
            sceneViewer.resetSelectedShade();
            roofMeshArr.forEach((roof: RoofMesh) => {
                const roofChildren = roof.children
                roofChildren.forEach((child: any) => {
                    if (child.name === 'shadePoint') {
                        child.visible = false
                    }
                })
            });
            // sceneViewer.setVisibleGroup("pathway", layerVisibilityState.pathway);
        }
    }, []);


    useEffect(() => {
        //split shadepoints based on roof
        setIsLoading(Object.values(needsUpdate).includes(true));
        const roofShadeData: RoofWiseShadePoint[] = [];
        roofMeshArr.forEach((roof: RoofMesh) => {
            if (roof.userData.roof_tag_id) {
                roofShadeData.push({
                    roofName: "Roof ID-" + roof.userData.roof_tag_id,
                    roofId: roof.roofFaceId,
                    shadePoints: roof.userData.shadeArrForRoof.map((child, index) => ({
                        shadePointName: (index + 1),
                        ptHashValue: Math.round(child.ptHashVal || 0)
                    }))
                });
            }
        })
        setRoofWiseShadePoints(roofShadeData);
    }, [needsUpdate]);

    const showLossesDetail = () => {
        sceneViewer.viewerAlert({
            show: true,
            title: "Losses Detail",
            message: <LossesInfoDetail vendor={selectedDropdownVendor}/>,
            messageType: "info",
            isModal: true
        })
    }

    const closeConfirm = () => {
        setShowToggleConfirm(false);
    }

    const resetToLastSelectedVendorOnCancel = () => {
        setSelectedDropdownVendor(selectedLossesVendor || "oneDRAW");
    }

    useEffect(() => {
        setSelectedDropdownVendor(selectedLossesVendor || "oneDRAW");
    }, []);

    useEffect(() => {
        setSelectedDropdownVendor(selectedLossesVendor || "oneDRAW");
    }, [selectedLossesVendor]);


    return (
        <>
            <div className='tab__inner'>
                <div className='tab__title'>
                    <span className='tab__title--text tab__title--flex'>Shade Point Properties</span>
                </div>

                <div className='tab__column'>
                    <div style={{justifyContent: 'space-between', marginBottom: '3px'}}
                         className='tab__column--title tab__title--flex tab__title--btns'>
                        Select Losses
                        <Flex>
                            <Button
                                size='small'
                                style={{border: 'none'}}
                                onClick={showLossesDetail}
                                title={'Detail Info'}>
                                <Info/>
                            </Button>
                            <Button
                                size='small'
                                style={{border: 'none'}}
                                onClick={revertToOriginaloneDRAWLoss}
                                title={'Revert to oneDRAW (Default)'}>
                                <BiReset/>
                            </Button>

                        </Flex>

                    </div>
                    <Select
                        value={selectedDropdownVendor}
                        allowClear
                        placeholder="Select Vendor..."
                        options={vendorOptions}
                        onSelect={(value) => handleVendorChange(value)}
                        style={{width: '100%'}}
                        showSearch={false}
                    />

                </div>

                    {
                        showToggleConfirm &&
                        <div className='tab__column'>
                        <ToggleLossesConfirm vendor={selectedDropdownVendor} callBackOnCancel={resetToLastSelectedVendorOnCancel} closeConfirm={closeConfirm} />
                        </div>
                    }



                <div
                    className='tab__column theme-based-text-color'>
                    <Accordion title='Shade Point Values' active={false}>
                        <br/>

                        <Alert style={{color: "black", marginBottom: '15px'}}
                               message="Shade Point Index starts from bottom left" type="info" showIcon/>
                        <Alert
                            style={{
                                color: "black"
                            }}
                            message="Blue Spheres indicate the Shade points on the Roof" type="info" showIcon/>

                        {isLoading ?
                            <>
                                <br/>
                                <Alert style={{color: "black"}}
                                       message="Shade Point values are being calculated" type="warning" showIcon/>
                            </>
                            : roofWiseShadePoints
                                .sort((a, b) => {
                                    const matchA = a.roofName.match(/\d+/);
                                    const matchB = b.roofName.match(/\d+/);
                                    const numA = matchA ? parseInt(matchA[0], 10) : 0;
                                    const numB = matchB ? parseInt(matchB[0], 10) : 0;
                                    return numA - numB;
                                })
                                .map((roof, roofIdx) => {
                                    if (roof.shadePoints.length === 0) return;
                                    return (
                                        <div
                                            key={roofIdx}>
                                            <br/>
                                            <span className='tab__column--subtitle'>{roof.roofName}</span>
                                            <div style={{height: '200px', overflow: 'auto'}}>
                                                <table className={"tab__table"} key={roofIdx}>
                                                    <thead>
                                                    <tr style={{position: 'sticky', top: '0',}}>
                                                        <th>Shade Point</th>
                                                        <th>Shade Weight Hash</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        roof.shadePoints.map((shadePoint, ptIdx) => {
                                                            return (
                                                                <tr className={selectedShade === `${roof.roofId}-${ptIdx}` ? 'selected' : ''}
                                                                    key={ptIdx} onClick={onClickRow}>
                                                                    <td id={`${roof.roofId}-${ptIdx}`}>{shadePoint.shadePointName}</td>
                                                                    <td id={`${roof.roofId}-${ptIdx}`}>{shadePoint.ptHashValue}</td>
                                                                </tr>

                                                            )
                                                        })
                                                    }
                                                    </tbody>
                                                </table>
                                            </div>
                                            <br/>
                                        </div>
                                    )
                                })
                        }
                    </Accordion>
                </div>

            </div>
        </>
    );
}

export default ShadePointProperties;